module.exports = __webpack_public_path__ + "img/icon_2_42.5ed5ad8c.png";